import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { LayoutDashboard } from "lucide-react";
 * // Use <LayoutDashboard /> instead
 */
export const DashboardIcon = createSVGWrapper(
  <>
    <path
      d="M13.5 4C13.5 3.44772 13.9477 3 14.5 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9H14.5C13.9477 9 13.5 8.55228 13.5 8V4Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M13.5 13C13.5 12.4477 13.9477 12 14.5 12H20C20.5523 12 21 12.4477 21 13V20C21 20.5523 20.5523 21 20 21H14.5C13.9477 21 13.5 20.5523 13.5 20V13Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M3 16C3 15.4477 3.44772 15 4 15H9.5C10.0523 15 10.5 15.4477 10.5 16V20C10.5 20.5523 10.0523 21 9.5 21H4C3.44772 21 3 20.5523 3 20V16Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M3 4C3 3.44772 3.44772 3 4 3H9.5C10.0523 3 10.5 3.44772 10.5 4V11C10.5 11.5523 10.0523 12 9.5 12H4C3.44772 12 3 11.5523 3 11V4Z"
      stroke="currentColor"
      strokeWidth="1.25"
    />
  </>
);
